/**
 * Helpers over the person unions of the API (`{ type: 'morale' } & LegalEntityDto |
 * { type: 'physique' } & NaturalPersonDto`), typed structurally so that every package's
 * PersonDto fits.
 */

interface LegalEntityLike {
  type: 'morale';
  companyName: string;
}

interface NaturalPersonLike {
  type: 'physique';
  firstName: string;
  lastName: string;
}

export type PersonLike = LegalEntityLike | NaturalPersonLike;

export const isLegalEntity = <T extends { type: string }>(person: T): person is Extract<T, { type: 'morale' }> =>
  person.type === 'morale';

/** Company name of a legal entity, "firstName lastName" of an individual. */
export const getPersonDisplayName = (person: PersonLike): string =>
  isLegalEntity(person) ? person.companyName : `${person.firstName} ${person.lastName}`;
